<template>
  <div class="top-tool-var-container">
    <div class="left_box" >
      <div class="top_bar_title_top" @click="testStopTimer"> {{ nickname }} </div>
      <div class="top_bar_right_care" :class="{ 'color_gray': isCare }" @click="toggleCare()">
        {{careText}}
      </div>
    </div>

    <div class="right_box" >
      <div class="right_box_text" @click="wantClick" v-if="userPoster !== ''">
        <span class="right_box_text_inline"
              v-track-event="{
                category: 'button',
                action: 'click',
                opt_label: '获取同款'
              }">
          获取同款
        </span>
      </div>

    </div>

    <van-dialog v-model="liuyanShow" :show-confirm-button="false">
      <div class="dialog-main">
        <div class="dialog-title hx-flex-c-c hx-flex-j-b">
          <div></div>
          <div style="font-size: 18px; color: #333; font-weight: bold">
            留言
          </div>
          <van-icon name="cross" @click="liuyanShow = false" />
        </div>
        <div class="dialog-content">
          <van-form class="my-form" :disabled="formLoading" @submit="onSubmit">
            <van-field
              required
              v-model="formData.content"
              name="content"
              label="留言"
              placeholder="请输入"
              :rules="rules['content']"
              type="textarea"
              rows="2"
              autosize
            />

            <van-field
              v-model="formData.sender"
              required
              name="sender"
              label="手机号码"
              placeholder="手机号码"
              :rules="rules['sender']"
            />

            <div class="hx-flex-c-c" style="padding: 36px 0 12px 0">
              <van-button
                plain
                hairline
                type="primary"
                round
                block
                :loading="formLoading"
                style="width: 10em; padding: 10px 24px; height: unset"
              >提交</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="qunliaoShow" :show-confirm-button="false">
      <div class="dialog-main">
        <div class="dialog-title hx-flex-c-c hx-flex-j-b">
          <div></div>
          <van-icon name="cross" @click="qunliaoShow = false" />
        </div>
        <div class="dialog-content">
          <img
            style="width: 90%; max-height: 70vh; object-fit: contain"
            :src="qrCodeGroup"
          />

          <div style="font-size: 14px; padding: 20px 0; color: #666">
            长按识别二维码添加微信
          </div>
          <!-- <a href="tel:13000000000">打电话</a> -->
        </div>
      </div>
    </van-dialog>

    <van-dialog class="custom_dialog_dark" v-model="wantShow" :show-confirm-button="false">
      <div class="dialog_main_dark">
        <div class="dialog_title_dark hx-flex-c-c hx-flex-j-b">
          <div style="width: 100%;text-align: center">
            制作属于你的AI智能体
          </div>
          <van-icon name="cross" @click="wantShow = false" />
        </div>
        <div class="dialog-content-custom">
          <div v-if=" userPoster !== '' ">
            <div class="step_title_box" style="margin: 0 0 27px 0">
              <div class="step_title">
                <div class="step_title_left">
                  01
                </div>
                <div class="step_title_right">
                  <span v-if="userPoster !== '' "> 长按图片识别购买 </span>
                </div>
              </div>
            </div>

            <div class="img_poster_box" v-show="userPoster !== ''" >
              <van-image class="img_box" lazy-load :src="userPoster">
                <template slot="error">加载失败</template>
              </van-image>
            </div>

          </div>

          <div class="step_title_box">
            <div class="step_title">
              <div class="step_title_left">
                02
              </div>
              <div class="step_title_right">
                请点击下载喵呜应用
              </div>
            </div>
          </div>
          <div class="step_content" style="margin-bottom: 36px">
            <div class="download_div">
              <van-button type="primary" size="middle" class="download_btn" @click="downloadApp"> 点击下载 </van-button>
            </div>
          </div>



          <div class="step_title_box" style="margin-top: 36px">
            <div class="step_title">
              <div class="step_title_left">
                03
              </div>
              <div class="step_title_right">
                注册喵呜账号
              </div>
            </div>
          </div>
          <div class="step_content" style="margin-bottom: 36px">
              使用激活码注册喵呜账号，开始制作您的专属AI智能体。
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog class="custom_dialog_dark" v-model="qrShow" :show-confirm-button="false">
      <div class="dialog_main_dark">
        <div class="dialog_title_dark hx-flex-c-c hx-flex-j-b" style="margin-top: 150px">
          <div style="width: 100%;text-align: center">
            长按扫码识别
          </div>
          <van-icon name="cross" @click="qrShow = false" />
        </div>
        <div class="dialog-content-custom">

          <div class="img_poster_box">
            <van-image lazy-load :src="qrCode" width="250" height="250" style="-webkit-touch-callout : none;">
              <template slot="error">加载失败</template>
            </van-image>
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="showAppDownInfo" show-cancel-button confirm-button-text="复制" :close-on-click-overlay="true" @confirm="sureCopy"
                class-name="copyDialog" :message="downLoadAppInfoTips" style="color: black">

    </van-dialog>

    <van-dialog class="dialog_care_dark" v-model="showCareDialog" :show-confirm-button="false">
      <div class="dialog_main_dark" >
        <div class="dialog_title_dark hx-flex-c-c hx-flex-j-b" style="padding-bottom: 8px">
          <div style="width: 100%;text-align: center">
          </div>
          <van-icon name="cross" @click="showCareDialog = false" color="white" />
        </div>
        <div class="dialog-content-custom1">
          <div class="text-care-love">
            <img  id="canvas_img" :src="miniQrCode"  width="160" height="160">
          </div>
          <div class="text-care-love" style="margin-top: 10px;color: white;line-height: 150%" v-show="sunSrc === ''">
            1.长按打开瞄呜AI智能体小程序<br>
            2.搜索框内粘贴他的昵称搜索<br>
            3.关注后就可以快速找到他啦<br>
          </div>
          <div class="text-care-love" style="margin-top: 10px;color: white;line-height: 150%" v-show="sunSrc !== ''">
            长按识别 进入瞄呜AI智能体小程序<br>
            关注后就可以快速找到他啦<br>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { feedback, follow, getSunImage, unfollow } from '@/api/app'
import { Dialog } from 'vant'
import Clipboard from 'clipboard'
import { url_to_query } from '@/plugins/getUrlParam'

export default {
  name: "TopToolBar",
  data() {
    return {
      getSame: require('@/assets/getSame.gif'),

      wantShow: false,
      qrShow: false,
      showCareDialog: false,
      qunliaoShow: false,
      liuyanShow: false,
      formLoading: false,
      qrCode: require('@/assets/qrcode.png'), // 安卓app下载地址
      miniQrCode: require('@/assets/miniqrcode.png'), // 小程序太阳码
      rules: {
        sender: [
          { required: true, trigger: "onBlur", message: "请留存手机号码" },
          {
            pattern:  /^[1-9]\d{10}$/, // /^.{5,}$/, // /^.{5,11}$/,
            message: "请留存你的手机号",
            trigger: "onChange",
          },
        ],
        content: [
          { required: true, trigger: "onBlur", message: "请输入留言内容" },
          {
            pattern: /^.{5,100}$/,
            message: "留言内容要在5到100个字之间",
            trigger: "onChange",
          },
        ],
      },
      formData: {
        title: "",
        sender: "",
        content: "",
      },
      // 下载应用复制粘贴
      clipboard: null,
      showAppDownInfo: false,
      downLoadAppInfoTips: '您可以复制下载地址',
      copyText: 'https://www.pgyer.com/meu_ai',
      // 新UI调整
      showPanel: false,
      sunSrc: ''
    };
  },
  computed: {
    nickname() {
      let username = this.vuex_app_user_info?.nickname || ''
      if (username.length <= 7) {
        return username
      } else {
        return username.substring(0, 7);
      }
    },
    isCare() {
      return this.$store.state.appletInfo.isCare
    },
    user_token() {
      return this.$store.state.appletInfo.user_token
    },
    biography() {
      return this.vuex_app_user_info?.biography || "";
    },
    qrCodeGroup() {
      return this.$store.state?.vuex_app_user_info?.wechat_qr_code || ''
    },
    userPoster() {
      return this.$store.state?.vuex_app_user_info?.wechat_mini_url || ''
    },
    careText(){
      return this.isCare ? '已关注' : '关注'
    },
  },
  mounted () {
  },
  beforeDestroy() {
    if (this.clipboard !== null){
      this.clipboard.destroy()
    }
    if (this.sunSrc !== ''){
      URL.revokeObjectURL(this.sunSrc)
    }
  },
  methods: {
    onChangeLiuYanShow(isShow) {
      console.log('enter this.$refs.myTopToolBar.onChangeLiuYanShow(isShow)')
      this.liuyanShow = isShow
    },
    onChangeQunLiaoShow(isShow) {
      if (!this.qrCodeGroup) {
       this.$myToast({
         type: "fail",
         message: "暂无二维码",
       });
       return;
     }
      this.qunliaoShow = isShow

    },
    async onSubmit(values) {
      try {
        this.formLoading = true;
        await feedback(this.formData);

        this.formLoading = false;
        // this.formData = this.$options.data()?.formData;
        this.liuyanShow = false;
        this.$myToast({
          type: "success",
          message: "留言成功",
        });
        // 防止还没关闭前报错
        this.$nextTick(() => {
          this.formData = this.$options.data()?.formData;
        });
      } catch (error) {
        console.error(
          "🚀 ~ file: TopToolBar.vue:160 ~ onSubmit ~ error : ",
          error
        );
        this.formLoading = false;
        this.$myToast({
          type: "fail",
          // message: error?.msg || "留言失败",
          message: "留言失败",
        });
      }
    },
    sureCopy() {
      // 复制到剪贴板
      this.clipboard = new Clipboard('.van-dialog__confirm', {
        text: () => this.copyText
      });

      this.clipboard .on('success', () => {
        console.log('复制成功')
        this.clipboard .destroy();
      });

      this.clipboard .on('error', () => {
        console.log('复制失败')
        this.clipboard .destroy();
      });
      // this.clipboard.onClick();
    },
    downloadApp() {
      let userAgent = navigator.userAgent.toLowerCase();

      /**
       * 是否小程序下
       * 是：弹窗 复制不同的信息
       * 否：二维码扫码或跳转连接进行下载
       */

      // 在网页内可通过window.__wxjs_environment变量判断是否在小程序环境，建议在WeixinJSBridgeReady回调中使用，也可以使用JSSDK 1.3.2提供的getEnv接口。
      // 相关接口 5  从微信7.0.0开始，可以通过判断userAgent中包含miniProgram字样来判断小程序web-view环境。
      // web-view下的页面内
      /* function ready() {
        console.log(window.__wxjs_environment === 'miniprogram') // true
      }
      if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
        document.addEventListener('WeixinJSBridgeReady', ready, false)
      } else {
        ready()
      } */

      if (userAgent.indexOf('miniprogram') !== -1) {
        console.log('在微信小程序中打开的webview');
        let tips, downLink
        if (!/iphone|ipad|ipod/.test(userAgent)){
          tips = "您可以复制 https://www.pgyer.com/meu_ai 到浏览器中打开下载"
          downLink = 'https://www.pgyer.com/meu_ai'
        } else {
          tips = "您可以复制'喵呜AI'到苹果应用商店进行下载"
          downLink = '喵呜AI'
        }
        // 无标题
        this.downLoadAppInfoTips = tips
        this.copyText = downLink
        this.showAppDownInfo = true
      } else {
        console.log('在浏览器中打开');
        /**
         *  IOS在微信中打开的网页，进行扫码跳转
         *   IOS不在微信中打开的网页，进行链接跳转
         *  android 手机在网页中打开的，直接进行连接跳转第三方分发网址
         */
        if (/iphone|ipad|ipod/.test(userAgent)) {
          console.log('当前用户为 iOS 环境')
          if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
            this.qrShow = true
          } else {
            window.location.href = 'https://apps.apple.com/cn/app/喵呜ai/id6462773304';
          }
        } else {
          console.log('当前用户不是 iOS 环境')
          // https://www.meupop.com/app-release.apk
          window.location.href = 'https://www.pgyer.com/meu_ai';//https://app.aigcpop.com/meu
        }

      }
    },
    testStopTimer() {
      this.$emit('testStopTimer', true)
    },
    clickCare() {
      console.log('enter clickCare')
      this.careLoveShow = false
      this.$toast.success('待实现：成功关注')
    },
    togglePanel(){
      this.showPanel = !this.showPanel
      this.$emit('changePanelShow', this.showPanel)
    },
    closePanel(){
      if(this.showPanel){
        this.showPanel = false
        this.$emit('changePanelShow', false)
      }
    },
    wantClick(){
      this.wantShow = true
      this.$emit('wantClick')
    },
    showSunImage() {
      this.showCareDialog = true
      getSunImage(this.user_token).then( res => {
        if(res.status === 'ok'){
          const data = res.data
          this.sunSrc = data.qr_code
          // 解码base64数据为二进制数据
          let binaryData = atob(this.sunSrc);

          // 将二进制数据转换为Uint8Array
          let uint8Array = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
          }

          // 创建Blob对象
          let blob = new Blob([uint8Array], { type: 'image/png' }); // 假设图片类型为PNG

          // 创建Blob URL
          this.miniQrCode = URL.createObjectURL(blob);

        }
      }).catch( error => {
        // 处理请求错误
        console.log('获取太阳码失败稍后再试', error)
        this.$myToast({
          type: "fail",
          message: "获取太阳码失败稍后再试。 " + (error?.msg || error?.code)
        })
      })
    },
    toggleCare() {
      if (!this.$store.state.weiXinMark){
        const phone = this.$store.state?.vuex_app_user_info?.phone
        if (!phone || phone === '' || typeof phone === 'undefined'){
          this.showSunImage()
        } else {
          let paramsObj = {
            phone: phone + ''
          }
          this.$emit('jumpMiniProgram', 0, paramsObj)
        }
      }
      else {
        /* if (this.user_token === ''){
          this.$myToast({
            type: "fail",
            message: "无鉴权信息 user_token",
          })
          return
        } */
        // 如果返回状态code=520，则弹出跳转小程序登录弹框
        let isWillCare = !this.isCare

        const phone = this.$store.state?.vuex_app_user_info?.phone
        if (!phone || typeof phone === '' || typeof phone === 'undefined'){
          this.$myToast({
            type: "fail",
            message: "无分身信息手机号",
          })
          return
        }
        const params = {
          phone_num: phone
        }

        if (isWillCare){
          // 关注
          follow(params, this.user_token).then( res => {
            this.$store.commit('updateIsCareStatus', isWillCare)
            this.$myToast({
              message: "关注成功"
            })
          }).catch( error => {
            // 处理请求错误
            this.$store.commit('updateIsCareStatus', !isWillCare)
            console.log('关注失败稍后再试', error)
            if (error.code === 520){
              this.$vuex('jumpLoginMessage', '您需要登录后使用该功能，是否通过小程序授权登录？')
              this.$vuex('loginMiniDialog', true)
            } else {
              this.$myToast({
                type: "fail",
                message: "关注失败稍后再试。 " + (error?.msg || error?.code)
              })
            }

          })
        } else {
          // 取消关注
          unfollow(params, this.user_token).then( res => {
            this.$store.commit('updateIsCareStatus', isWillCare)
            this.$myToast({
              message: "取消关注"
            })
          }).catch( error => {
            // 处理请求错误
            this.$store.commit('updateIsCareStatus', !isWillCare)
            if (error.code === 520){
              this.$vuex('jumpLoginMessage', '您需要登录后使用该功能，是否通过小程序授权登录？')
              this.$vuex('loginMiniDialog', true)
            } else {
              console.log('取关失败稍后再试')
              this.$myToast({
                type: "fail",
                message: "取消关注失败，请稍后再试。 " + (error?.msg || error?.code)
              })
            }
          })
        }
      }

    },


  },
};
</script>

<style lang="less" scoped>
.top-tool-var-container {
  position: absolute;
  // width: 100%;// old
  // width: calc(100vw - 16px); // noah
  width: calc(100% - 16px);
  height: 50px;
  top: 12px;
  left: 0;
  padding-left: 16px;
  z-index: 50; // 避免被输入条覆盖
  // padding: 0 10px;
  color: #fff;
  text-align: center;
  display: flex;
  font-size: 12px;
  line-height: 1;

  float: left;
  align-items: center;
  justify-content: space-between;
  .left_box{
    float: left;
    display: flex;
    background: rgba(0, 0, 0, 0.3);
    // backdrop-filter: blur(8px);
    border-radius: 30px;
    height: 34px;
    // width: 168px;
    padding: 0 4px 0 16px;
    display: flex;
    align-items: center;
    .top_bar_title_top{
      float: left;
      min-width: 68px;
      max-width: 108px;
      height: 20px;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      // 超出内容省略号
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
    .top_bar_right{
      float: right;
      width: 34px;
      height: 34px;
      background: #1EDF41;
      border-radius: 50%;
      line-height: 42px;
      margin-top: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .top_bar_right_care{
      float: right;
      width: 56px;
      height: 26px;
      background: #fe2c55;
      border-radius: 17px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
      font-style: normal;
    }
  }
  .right_box{
    width: 96px;
    height: 32px;
    padding-right: 16px;
    @keyframes heartBeat {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2); /* 在动画的中间帧设置放大的尺寸 */
      }
      100% {
        transform: scale(1);
      }
    }
    .right_box_text{
      width: 76px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      font-weight: 400;
      background: rgba(30,223,65, 1);
      border-radius: 6px;

      //animation: zoomIn;
      //animation-duration: .5s;
      //animate-delay: 1.2s;
      display: inline-block;
      animation: heartBeat;
      animation-duration: 2.2s;
      animate-delay: 2s;
      // animate-infinite: infinite
      animation-iteration-count: infinite;


      .right_box_text_inline{
        opacity: 1;
        color: #FFFFFF;
      }
    }
  }

}
.btn {
  flex: 1;
  padding: 8px 12px;
}
.btn:active {
  background: rgba(0, 0, 0, 0.3);
}
.btn:first-child {
  padding-left: 18px;
}
.btn:last-of-type {
  padding-right: 18px;
}
.icon {
  color: #1edf41;
  font-size: 1.7em;
  margin-bottom: 2px;
}

.dialog-main {
  padding: 16px;
  color: #000;
}
.dialog-title {
  line-height: 1;
  padding-bottom: 16px;
}

.my-form {
  .van-cell {
    display: block;
  }
  .van-cell::after {
    border: none;
    border-bottom: none;
  }
  ::v-deep .van-field__value {
    background: #f6f6f6;
    padding: 8px 10px;
    border-radius: 4px;
  }
}

.custom_dialog_dark{
  background: #252525;
  width: 100vw;
  height: 100vh;
  margin-top: 5vh;
}
.dialog_care_love{
  width: 80%;
  height: 200px;
  background: white;
  color: black;
  margin: 0 auto;

  .text-care-love{
    float: left;
    width: 100%;
    color: rgba(174, 174, 174, 1);
    margin-bottom: 50px;
  }
  .btn-care-love{
    float: left;
    width: 100%;
    background: rgba(255, 4, 0, 1);
    color: white;
    font-size: 18px;
    border-radius: 15px;
  }
}
.dialog_care_dark{
  width: 80%;
  height: 318px;
  background: rgba(37, 37, 37, 1);
  color: white;
  font-size: 16px;
  margin: 0 auto;

  .text-care-love{
    float: left;
    width: 100%;
    color: rgba(174, 174, 174, 1);
  }
}
.dialog_main_dark {
  padding: 16px;
  color: white;
  // transform: translateZ(2px);
}
.dialog_title_dark {
  width: 100%;
  height: 32px;
  line-height: 1;
  padding-bottom: 16px;
  text-align: center;
}

.dialog-content-custom{
  width: 100%;
  height: calc(100vh - 64px);
  overflow: auto;
  .step_title_box{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 36px;
    .step_title{
      float: left;
      width: 246px;
      height: 28px;
      line-height: 28px;
      background-image: url("./../../../assets/stepLine.png");
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 auto;
      .step_title_left{
        float: left;
        width: 50px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        margin-right: 10px;
      }
      .step_title_right{
        float: right;
        max-width: 190px;
        height: 25px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        text-align: left;
      }
    }
  }

  .line_get_fun_1{
    float: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin: 16px 0 10px 0;
    display: flex;
    justify-content: center;
    .get_fun_1{
      width: 46px;
      height: 20px;
      padding: 2px 12px;
      background: #1edf41;
      color: black;
      font-size: 12px;
      border-radius: 5px;
    }
  }

  .step_content{
    float: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin: 16px 0 12px 0;


    .download_div{
      float: left;
      width: 100%;
      height: 40px;
      margin-bottom: 12px;
      .download_btn{
        width: 134px !important;
        height: 38px !important;;
        background: #1edf41;
        border-radius: 5px;
        font-size: 18px;
        font-weight: 500;
        color: black;
      }
    }
    .download_tip{
      float: left;
      width: 100%;
      height: 20px;
    }
  }

  .img_poster_box{
    float: left;
    width: 100%;
    margin-bottom: 30px;

  }
  .img_box{
    width: 70%;
  }
}


</style>
<style lang="less">
.step_content{
  img{
    -webkit-touch-callout : none;
  }
}
.color_gray{
  background: #adadad !important;
}
</style>
